const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { group: groupApi } = require('@doctoroncallcom/api')
const {
  GET_GROUP_LIST,
  GET_GROUP,
  CREATE_GROUP,
  UPDATE_GROUP,
  DELETE_GROUP,
} = require('./constants')

const {
  getGroupListSuccess,
  getGroupListError,
  getGroupSuccess,
  getGroupError,
  createGroupSuccess,
  createGroupError,
  updateGroupSuccess,
  updateGroupError,
  deleteGroupSuccess,
  deleteGroupError
} = require('./actions')

const getGroupList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_GROUP_LIST),
  mergeMap(action => groupApi.getGroupListApi(api, {
    search: action.payload.search,
    take: action.payload.take,
    skip: action.payload.skip,
  })
    .then(response => getGroupListSuccess(response.data))
    .catch(error => getGroupListError(error))),
)

const getGroup = (action$, state$, { api }) => action$.pipe(
  ofType(GET_GROUP),
  mergeMap(action => groupApi.getGroupApi(api, action.payload.id)
    .then(response => getGroupSuccess(response.data))
    .catch(error => getGroupError(error))),
)

const createGroup = (action$, state$, { api }) => action$.pipe(
  ofType(CREATE_GROUP),
  mergeMap(action => groupApi.createGroupApi(api, action.payload.groupData)
    .then(response => createGroupSuccess(response.data))
    .catch(error => createGroupError(error))),
)

const updateGroup = (action$, state$, { api }) => action$.pipe(
  ofType(UPDATE_GROUP),
  mergeMap(action => groupApi.updateGroupApi(api, action.payload.id, action.payload.groupData)
    .then(response => updateGroupSuccess(response.data))
    .catch(error => updateGroupError(error))),
)

const deleteGroup = (action$, state$, { api }) => action$.pipe(
  ofType(DELETE_GROUP),
  mergeMap(action => groupApi.deleteGroupApi(api, action.payload.id)
    .then(response => deleteGroupSuccess(response.data))
    .catch(error => deleteGroupError(error))),
)

module.exports = {
  getGroupList,
  getGroup,
  createGroup,
  updateGroup,
  deleteGroup,
}
